import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../assets/images/Dashboard/chevron-down.svg';
import ascToDesc from '../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../assets/images/CustomerManagement/descToAsc.svg';
import PaginationComponent from '../PaginationComponent';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import SbActionDropdownButton from '../Buttons/SbActionDropdownButton';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import noDataFound from '../../assets/images/no-data-found.svg';
import noModuleAccess from '../../assets/images/no-module-access.svg';
import moment from 'moment';
import { Link, useLocation } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import SbCancelBtn, { SBSaveUpdateBtn } from '../Buttons/Buttons';
import * as HeaderAuthentication from '../HeaderAuthentication';
import { useDispatch } from 'react-redux';
import { postResendVerifyEmail, postSwitchToClientDatas } from '../../redux/action';
import { FaCheck, FaTimes } from "react-icons/fa";

const columns = [
    { id: 'CompanyID', label: 'ID', align: 'left', minWidth: '80px' },
    { id: 'CompanyCode', label: 'COMPANY CODE', align: 'left', minWidth: '180px' },
    { id: 'CompanyName', label: 'COMPANY', align: 'left', minWidth: '180px' },
    { id: 'ContactPerson', label: 'NAME', align: 'left', minWidth: '150px' },
    // { id: 'relationshipType', label: 'RELATIONSHIP TYPE ', align: 'left', minWidth: '200px' },
    { id: 'NoOfLicenses', label: 'NO.OF.LICENSE', align: 'left', minWidth: '100px' },
    { id: 'EmailID', label: 'EMAIL', align: 'left', minWidth: '250px' },
    { id: 'Address', label: 'ADDRESS', align: 'left', minWidth: '250px' },
    { id: 'StartDate', label: 'START DATE', align: 'left', minWidth: '180px' },
    { id: 'EndDate', label: 'END DATE', align: 'left', minWidth: '180px' },
    // { id: 'assignedModules', label: 'ASSIGNED MODULES', align: 'left', minWidth: '200px' },
    { id: 'Status', label: 'STATUS', align: 'left', minWidth: '130px' },
    { id: 'action', label: 'ACTION', align: 'left', minWidth: '80px', sortable: false },
];

const SortableHead = SortableContainer(({ children }) => {
    return (
        <TableHead>
            <TableRow>{children}</TableRow>
        </TableHead>
    );
});

const SortableCell = SortableElement(({ value }) => {
    return <TableCell>{value}</TableCell>;
});


const CustomerManagementTable = ({ companyData = [], selectedColumns, loading, handleOpenModal, handleViewDetails, handleOpenValueFilterModal, page, setPage, rowsPerPage, setRowsPerPage, moduleData, totalDataCount, showSwitchModal, setShowSwitchModal, handleSwitchClientCancel, handleSwitchClientConfirm, signInDetails, setCompanyId, customerManagementData }) => {

    // eslint-disable-next-line react-hooks/exhaustive-deps
    // const companyData = props.companyData || [];

    const dispatch = useDispatch();
    // const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    // const signInType = signInDetails ? signInDetails[0].SignInType : null;
    const DateFormat = signInDetails[0]?.DateFormat;

    // Get selected columns (based on `selectedColumns` prop)
    const filteredColumns = columns.filter((column) =>
        selectedColumns.includes(column.label)
    );

    const getStoredColumnsOrder = () => {
        const savedOrder = localStorage.getItem('companyColumnsOrder');
        return savedOrder ? JSON.parse(savedOrder) : columns.map((col) => col.id);
    };

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [clickedCell, setClickedCell] = useState({ rowId: null, columnId: null }); // Track clicked cell
    const [columnsOrder, setColumnsOrder] = useState(getStoredColumnsOrder());
    const [customerStatus, setCustomerStatus] = useState("");
    const [companyName, setCompanyName] = useState("");

    // Pagination state
    // const [page, setPage] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = useState(10); // Set initial rows per page
    const [paginatedData, setPaginatedData] = useState([]);
    // const [showSwitchModal, setShowSwitchModal] = useState(false); // For new modal
    const location = useLocation();

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const onReorderEnd = ({ oldIndex, newIndex }) => {
        const newOrder = Array.from(columnsOrder);
        const [moved] = newOrder.splice(oldIndex, 1);
        newOrder.splice(newIndex, 0, moved);
        setColumnsOrder(newOrder);
        localStorage.setItem('companyColumnsOrder', JSON.stringify(newOrder)); // Store new order
    };

    const sortedData = React.useMemo(() => {
        const stabilizedData = companyData.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) {
                return -1 * orderModifier;
            }
            if (a[0][orderBy] > b[0][orderBy]) {
                return 1 * orderModifier;
            }
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [companyData, order, orderBy]);

    // Pagination logic
    // useEffect(() => {
    //     const start = page * rowsPerPage; // Updated page logic to 0-based
    //     const end = start + rowsPerPage;
    //     setPaginatedData(sortedData.slice(start, end));
    // }, [sortedData, page, rowsPerPage]);

    useEffect(() => {
        if (!companyData || companyData.length === 0) {
            console.warn("⚠️ No Company Data Found!");
            setPaginatedData([]);
            return;
        }

        // Sort data based on order & orderBy
        const sorted = [...companyData].sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            return a[orderBy] < b[orderBy] ? -1 * orderModifier : 1 * orderModifier;
        });

        // Calculate pagination
        const maxPage = Math.ceil(sorted.length / rowsPerPage);
        const newPage = Math.min(page, maxPage - 1); // Prevents out-of-range pages

        const start = newPage * rowsPerPage;
        const end = start + rowsPerPage;
        const paginated = sorted.slice(start, end);

        setPaginatedData(paginated);
    }, [companyData, order, orderBy, page, rowsPerPage]);


    const handlePageChange = (newPage) => {
        setPage(newPage - 1); // Handle 1-based to 0-based page index for slicing
    };
    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0); // Reset to the first page when rows per page changes
    };

    // const handleSwitchClientConfirm = (e) => {
    //     e.preventDefault();

    //     let SigninID = null;

    //     if (signInType === "SuperAdmin") {
    //         SigninID = signInDetails[0].SuperAdminID; // Use SuperAdminID for SuperAdmin type
    //     } else if (signInType === "ClientAdmin") {
    //         SigninID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin type
    //     } else if (signInType === "User") {
    //         SigninID = signInDetails[0].UserID; // Use UserID for User type
    //     }

    //     const data = {
    //         "SigninID": SigninID,
    //         "CompanyID": 40
    //     };

    //     let requestOption = {
    //         method: "POST",
    //         mode: "cors",
    //         headers: HeaderAuthentication.postExcomatixAuth,
    //         body: JSON.stringify(data),
    //     };

    //     dispatch(postSwitchToClientDatas(requestOption, handleSwitchClientCancel));
    // };

    // const handleSwitchClientCancel = () => {
    //     setShowSwitchModal(false);
    // };

    const handleResendEmailVerification = (EncCompanyCode, EncSignInType) => {
        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({
                Company_Code: EncCompanyCode, // Use companyCode passed from the button
                SignInType: EncSignInType
            }),
        };
        dispatch(postResendVerifyEmail(requestOption, customerManagementData));
    };

    return (
        <>
            {moduleData?.CanView === true ? (
                <>
                    <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
                        <Table>
                            {/* <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }} className='table-header-div'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {column.label}
                                        {column.sortable !== false && (
                                            <IconButton
                                                size="small"
                                                onClick={(event) => handleRequestSort(event, column.id)}
                                            >
                                                <img src={SortIcon} alt="Sort" />
                                            </IconButton>
                                        )}
                                    </div>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead> */}

                            <SortableHead axis="x" onSortEnd={onReorderEnd}>
                                {columnsOrder.map((columnId, index) => {
                                    const column = columns.find(col => col.id === columnId);
                                    if (!column) return null; // Skip if column doesn't exist

                                    // Only display columns that are in filteredColumns
                                    if (!filteredColumns.find(col => col.id === columnId)) {
                                        return null;
                                    }
                                    return (
                                        <SortableCell key={column.id} index={index} value={
                                            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', minWidth: column.minWidth }} className='table-header-div'>
                                                {column.label}
                                                {column.sortable !== false && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={(event) => handleRequestSort(event, column.id)}
                                                    >
                                                        <img src={SortIcon} alt="Sort" />
                                                    </IconButton>
                                                )}
                                            </div>
                                        } />
                                    );
                                })}
                            </SortableHead>
                            <TableBody>
                                {
                                    loading ? (
                                        [...Array(rowsPerPage)].map((_, index) => (
                                            <TableRow key={index}>
                                                {columns.map((column) => (
                                                    <TableCell key={column.id} align={column.align}>
                                                        <Skeleton height={40} />
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))
                                    ) : paginatedData.length === 0 ? (
                                        // Display "No Data Found" row if no data is present in the paginated data
                                        <TableRow>
                                            <TableCell colSpan={columns.length} align="center">
                                                <img src={noDataFound} alt="" style={{ height: "250px", width: "280px" }} />
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        paginatedData.map((customer) => (
                                            <TableRow key={customer.id}
                                                // className='table-row-data-container'
                                                className={`table-row-data-container ${customer.Expired === "Yes" ? "expired-row" : ""}`}
                                            >
                                                {columnsOrder.map((columnId) => {
                                                    const column = columns.find((col) => col.id === columnId);
                                                    if (!column || !filteredColumns.find(col => col.id === columnId)) {
                                                        return null; // Skip if column doesn't exist or not selected
                                                    }
                                                    return (
                                                        <TableCell
                                                            key={column.id}
                                                            align={column.align}
                                                            className={clickedCell.rowId === customer.CompanyID && clickedCell.columnId === column.id ? 'clicked-value' : ''}
                                                            onMouseDown={() => setClickedCell({ rowId: customer.CompanyID, columnId: column.id })}
                                                            onMouseUp={() => setClickedCell({ rowId: null, columnId: null })}
                                                            onMouseLeave={() => setClickedCell({ rowId: null, columnId: null })}
                                                        >
                                                            {column.id === 'Status' ? (
                                                                // <span
                                                                //     className={`status-badge ${customer.Status === 'Active' ? 'complete-status no-dropdown-badge' : 'cancel-status no-dropdown-badge'}`}
                                                                // >
                                                                //     {customer.Status}
                                                                // </span>
                                                                <span
                                                                    className={`status-badge ${customer.Expired === "Yes"
                                                                        ? "inprogress-status no-dropdown-badge" // If expired, use cancel badge
                                                                        : customer.Status === "Active"
                                                                            ? "complete-status no-dropdown-badge"
                                                                            : "cancel-status no-dropdown-badge"
                                                                        }`}
                                                                >
                                                                    {customer.Expired === "Yes" ? "Expired" : customer.Status}
                                                                </span>
                                                            ) : column.id === "EmailID" ? (
                                                                <div className="email-container">
                                                                    <span className="d-flex flex-column">
                                                                        {customer.IsEmailVerified ? (
                                                                            <div className="d-flex align-items-center">
                                                                                <p className="verified-email m-0"><FaCheck className="text-success" /></p>&nbsp;&nbsp;
                                                                                <span>{customer.EmailID}</span>
                                                                            </div>
                                                                        ) : (
                                                                            <div>
                                                                                <div className="d-flex align-items-center">
                                                                                    <p className="unverified-email m-0"><FaTimes className="text-danger" /></p>&nbsp;&nbsp;
                                                                                    <span>{customer.EmailID}</span>
                                                                                </div>
                                                                                {/* "Verify" link */}
                                                                                <button className="verify-email-btn"
                                                                                    onClick={() => { handleResendEmailVerification(customer.EncCompanyCode, customer.EncSignInType) }}
                                                                                >
                                                                                    Send Verification Email
                                                                                </button>
                                                                            </div>

                                                                        )}
                                                                    </span>
                                                                </div>
                                                            ) :
                                                                column.id === 'action' ? (
                                                                    // <img src={action} alt="" onClick={(event) => handleActionClick(event, customer)} />
                                                                    <SbActionDropdownButton
                                                                        openAddModal={() => {
                                                                            handleOpenModal(customer.CompanyCode, customer.CompanyID)
                                                                        }}
                                                                        addBulkModel={() => handleViewDetails(customer.CompanyCode, customer.CompanyID)}
                                                                        moduleData={moduleData}
                                                                    />
                                                                ) : (
                                                                    <span
                                                                        // onClick={() => {
                                                                        //     setClickedCell({ rowId: customer.id, columnId: column.id }); // Track clicked cell
                                                                        //     handleOpenValueFilterModal(); // Open modal
                                                                        // }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation(); // Prevent triggering the row click event
                                                                            if (location.state?.isSwitchToClient) {
                                                                                setShowSwitchModal(true); // Open new modal
                                                                                setCompanyId(customer.CompanyID)
                                                                                setCustomerStatus(customer.StatusID)
                                                                                setCompanyName(customer.CompanyName);
                                                                            } else {
                                                                                const columnValue = customer[column.id];

                                                                                // Alert the column value
                                                                                // alert(`Value of column ${column.id}: ${columnValue}`);
                                                                                setClickedCell({ rowId: customer.id, columnId: column.id }); // Track clicked cell
                                                                                handleOpenValueFilterModal(column.id, columnValue); // Open original modal
                                                                            }
                                                                        }}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        {column.id === 'StartDate' ? (
                                                                            moment(customer.StartDate).isValid() ? moment(customer.StartDate).format(DateFormat) : "Invalid Date"
                                                                        ) : column.id === 'EndDate' ? (
                                                                            moment(customer.EndDate).isValid() ? moment(customer.EndDate).format(DateFormat) : "Invalid Date"
                                                                        ) : customer[column.id]}
                                                                    </span>
                                                                )
                                                            }
                                                        </TableCell>

                                                    )
                                                })}

                                            </TableRow>
                                        )
                                        ))}

                            </TableBody>
                        </Table>
                        <Modal show={showSwitchModal} onHide={handleSwitchClientCancel} className='add-role-modal'>
                            <Modal.Header closeButton>
                                <Modal.Title>Switch to Client</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {/* <p>Are you sure you want to switch to this client?</p> */}
                                {customerStatus === 6 ? (
                                    <p>Switching to the client is not possible as the customer is Inactive.</p>
                                ) : customerStatus === 7 ? (
                                    <p>Switching to the client is not possible as the customer is Disabled.</p>
                                ) : (
                                    <p>Are you sure you want to switch to <strong>{companyName}</strong> client?</p>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                <SbCancelBtn btnName="Cancel" onClickEffect={handleSwitchClientCancel} />
                                {/* <SBSaveUpdateBtn btnName="Confirm" onClickEffect={handleSwitchClientConfirm} /> */}
                                {customerStatus !== 6 && customerStatus !== 7 && (
                                    <SBSaveUpdateBtn btnName="Confirm" onClickEffect={handleSwitchClientConfirm} />
                                )}
                            </Modal.Footer>
                        </Modal>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={() => setAnchorEl(null)}
                            className='header-menu-items'
                        >
                            <MenuItem onClick={() => handleSortOrderChange('asc')} className='header-menu-options'>
                                <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                                Ascending to Descending
                            </MenuItem>
                            <MenuItem onClick={() => handleSortOrderChange('desc')} className='header-menu-options'>
                                <img src={descToAsc} alt="" />&nbsp;&nbsp;
                                Descending to Ascending
                            </MenuItem>
                        </Menu>
                    </TableContainer >
                    {/* Use PaginationComponent */}
                    < PaginationComponent
                        totalItems={totalDataCount}
                        itemsPerPage={rowsPerPage}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleRowsPerPageChange}
                    />
                </>
            ) : (
                <div className='d-flex align-items-center justify-content-center p-3'>
                    <img src={noModuleAccess} alt="" />
                </div>
            )
            }
        </>
    );
};

export default CustomerManagementTable;

